import React from "react";
import { Box, Button, Card, Grid, Icon, Link, Modal, Progress, Text } from "~/components-shared";
import styled from "styled-components";
import StyledIcon from "~/components/StyledIcon";
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const StyledLink = styled(Link)`
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const MessagingCard = _ref => {
  let {
    widget,
    ...rest
  } = _ref;
  const {
    total,
    channels
  } = widget.data;
  const [open, setOpen] = React.useState(false);
  const overall = total.messages + total.reactions;
  const cardItem = channel => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLink, {
      href: channel.url,
      color: "text",
      fontSize: 4
    }, "#", channel.name), /*#__PURE__*/React.createElement(Progress, {
      values: [channel.messages / (overall || 1) * 100, channel.reactions / (overall || 1) * 100],
      height: 2,
      labels: [`Messages: ${channel.messages}`, `Reactions: ${channel.reactions}`],
      colors: ["#A0D7E7", "#85b8ff"]
    }), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      fontSize: 3
    }, channel.messages + channel.reactions));
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 5
    }
  }, "Messaging"), total.messages + total.reactions > 0 ? /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "auto minmax(100px, 30%) 1rem",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Link, {
    color: "text",
    weight: "semiBold",
    fontSize: 4
  }, "Total"), /*#__PURE__*/React.createElement(Progress, {
    values: [total.messages / (overall || 1) * 100, total.reactions / (overall || 1) * 100],
    height: 2,
    labels: [`Messages: ${total.messages}`, `Reactions: ${total.reactions}`],
    colors: ["#A0D7E7", "#85b8ff"]
  }), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3
  }, total.messages + total.reactions), channels.slice(0, 6).map(channel => cardItem(channel))) : /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    justify: "center",
    s: {
      mt: 8
    }
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "chat",
    color: "translucentPrimary"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "400px"
    }
  }, "No messages")), channels.length > 6 && /*#__PURE__*/React.createElement(Box, {
    justify: "end",
    s: {
      mt: 2
    }
  }, /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    onClick: () => setOpen(true),
    fontSize: 4
  }, "See all", /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    s: {
      ml: 1,
      mt: -0.5
    }
  }))), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })), /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    title: "Messaging channels",
    onClose: () => setOpen(false),
    maxWidth: "600px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "auto minmax(100px, 30%) 1rem",
    align: "center",
    gap: 3
  }, channels.map(item => cardItem(item)))))));
};
export default MessagingCard;